import React, { useId, useState } from 'react'
import { exactRangeText, MAX_RANGE_DAYS, pickerDay, RANGES, rangeTooLong } from '../audit/filters-model'
import './time-range-filter.scss'

// The house time range (owner 2026-10-29: telemetry's dates should work "like
// the audit log and request log"): one select of presets -- Any time (when
// offered), Last 24 hours ... Last 12 months -- and "Custom range…", which
// shows a From and a To day picker, each with its word beside it (never a
// placeholder drawn over the field: Safari draws the field's own text under
// it). The Audit log's filter column and the AI tools telemetry toolbar both
// draw this one control, so the two can't drift.
//
// value: { range, from, to } as filters-model reads it -- range is a preset's
//   value, 'all' or 'custom'; a custom end is a day (YYYY-MM-DD) or an exact
//   instant (a calendar click). Other keys of value are handed back
//   untouched, so a page may pass its whole filters object.
// onChange(next): { ...value, range } on a pick, { ...value, from | to } on a
//   day.
// label: the select's name ("When", "Received").
// allTime: offer "Any time" (else it shows only while it is the value).
// capped: the server refuses a custom window over MAX_RANGE_DAYS (content's
//   audit reads): a longer one is never handed on, and it says so.
// inline: the toolbar's form (a .sw-toolbar row) -- the pickers beside the
//   select in one group ("<label> range") that never wraps apart, without
//   the column's hints.
export const TimeRangeFilter = ({ value, onChange, label = 'When', allTime = false, capped = false, inline = false }) => {
  const ids = { from: useId(), to: useId() }
  const [tooLong, setTooLong] = useState(false)
  const f = value || {}

  const pick = range => {
    setTooLong(false)
    onChange({ ...f, range })
  }
  const setDay = patch => {
    const next = { ...f, ...patch }
    const over = capped && rangeTooLong(next)
    setTooLong(over)
    if (!over) onChange(next)
  }

  const select = (
    <select className="form-select form-select-sm" aria-label={label} title={inline ? label : undefined} value={f.range} onChange={e => pick(e.target.value)}>
      {(allTime || f.range === 'all') && <option value="all">Any time</option>}
      {RANGES.map(r => <option key={r.value} value={r.value}>{r.label}</option>)}
    </select>
  )
  const days =
    <>
      <label className="sw-hint small tr-day" htmlFor={ids.from}>From
        <input id={ids.from} type="date" className="form-control form-control-sm" value={pickerDay(f.from)} max={pickerDay(f.to, true) || undefined} onChange={e => setDay({ from: e.target.value })} />
      </label>
      <label className="sw-hint small tr-day" htmlFor={ids.to}>To
        <input id={ids.to} type="date" className="form-control form-control-sm" value={pickerDay(f.to, true)} min={pickerDay(f.from) || undefined} onChange={e => setDay({ to: e.target.value })} />
      </label>
    </>
  const over = tooLong && <span className="text-danger small" role="alert">{`Choose a range of ${MAX_RANGE_DAYS} days or less.`}</span>

  if (inline) {
    return (
      <div className="tr-filter tr-inline" role="group" aria-label={`${label} range`}>
        {select}
        {f.range === 'custom' && days}
        {over}
      </div>
    )
  }

  return (
    <>
      {select}
      {f.range === 'custom' &&
        <div className="au-dates">
          {days}
          {exactRangeText(f) && <span className="sw-hint small">{exactRangeText(f)}</span>}
          {over}
          <span className="sw-hint small">Times are in your time zone; exports record the exact range.</span>
        </div>}
    </>
  )
}
